import Snackbar from "@mui/material/Snackbar";
import SnackbarContent from "@mui/material/SnackbarContent";
import RSButton from "ds_legacy/components/RSButton";
import { ERROR_COLOR } from "ds_legacy/materials/colors";
import { padding, sizing } from "ds_legacy/materials/metrics";
import { useTranslations } from "translations";

type ErrorSnackProps = {
  count: number;
  reset: () => void;
};

export default function ErrorSnackbar({ count, reset }: ErrorSnackProps) {
  const translations = useTranslations();

  return (
    <Snackbar anchorOrigin={{ horizontal: "center", vertical: "bottom" }} open>
      <SnackbarContent
        action={[
          <RSButton
            key="network-checker-retry"
            color="error"
            id="retry"
            inverted
            loading="na"
            variant="text"
            onClick={reset}
          >
            {translations.networkChecker.retry}
          </RSButton>,
        ]}
        aria-describedby="network-checker-snackbar"
        message={translations.networkChecker.retryingMessage({
          count: count.toString(),
        })}
        sx={{
          backgroundColor: ERROR_COLOR,
          marginBottom: sizing(2),
          padding: padding(0, 3),
        }}
      />
    </Snackbar>
  );
}
